import { Stack, Slider, Text, Tooltip } from "@mantine/core";
import { useAppStore } from "../../store/appStore";

const MARKS = [10, 30, 50, 70, 90].map((v) => ({
  value: v,
  label: `${v}km`,
}));

const DISABLED_MSG = "Select a datasource first";

export function RadiusSlider({ hideLabel }: { hideLabel?: boolean }) {
  const { selectedHindcast, radius, setRadius } = useAppStore();
  const disabled = selectedHindcast == null;

  return (
    <Stack id="tour-radius" gap={4}>
      {!hideLabel && (
        <Text size="sm" fw={500}>
          Search radius
        </Text>
      )}
      <Tooltip label={DISABLED_MSG} disabled={!disabled} position="bottom">
        <Slider
          value={radius}
          onChange={setRadius}
          disabled={disabled}
          min={10}
          max={90}
          step={5}
          marks={MARKS}
          label={(v) => `${v} km`}
          mb="md"
          styles={{ markLabel: { color: "#73d7ed" } }}
        />
      </Tooltip>
    </Stack>
  );
}
